<template>
  <div class="reasons">
    <div class="reasons-row container" data-aos="fade-up" data-aos-duration="1500">
      <MyTitle>
        <template v-slot:title>选择我们的<i> {{ reasonList.length }} </i>大理由</template>
        <template v-slot:subtitle>涓涓细流，汇入滔滔不绝的大江里，以博大精深的内涵和宽广的胸怀与时俱进、不断创新</template>
      </MyTitle>
      <ul class="reasons-list">
        <li v-for="(item, index) in reasonList" :key="item.id" data-aos="fade-left" data-aos-duration="1500">
          <div class="reasons-text" v-if="!(index%2)" style="padding-left: 30px; box-sizing: border-box">
            <b>{{ item.title }}</b>
            <p>{{ item.subtitle }}</p>
            <span>{{ item.description }}</span>
          </div>
          <div class="reasons-img">
            <div class="reasons-img-index">
              <b>0{{ index + 1 }}</b>
              <p><b>—</b></p>
            </div>
            <el-image :src="item.image_url" :key="item.id" lazy></el-image>
          </div>
          <div class="reasons-text" v-if="index%2">
            <b>{{ item.title }}</b>
            <p>{{ item.subtitle }}</p>
            <span>{{ item.description }}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Reasons",
  data() {
    return {
      reasonList: []
    }
  },
  methods: {
    async getReasonList() {
      let results = await this.$api.reqReasonList()

      if (results.status === 200) {
        this.reasonList = results.results
      } else {
        this.$message({showClose: true, message: "理由列表请求失败！", type: "error"})
      }
    },
  },

  mounted() {
    this.getReasonList()
  }
}
</script>

<style scoped lang="less">
.reasons {
  margin: 80px 0 100px 0;

  .reasons-row {

    .reasons-list {
      margin-top: 50px;

      li {
        display: flex;
        justify-content: space-between;
        margin-bottom: 40px;

        & > div {
          width: 560px;
          height: 300px;
        }

        .reasons-img {
          position: relative;
          background-color: #A6A6BA;
          background-size: 100% 100%;
          background-repeat: no-repeat;

          .reasons-img-index {
            padding-top: 15px;
            left: 20px;
            top: -30px;
            position: absolute;
            box-sizing: border-box;
            width: 88px;
            height: 111px;
            background-color: #1E50AE;
            font-size: 40px;
            color: white;
            text-align: center;
            z-index: 99;

            p {
              line-height: 12px;
            }
          }

          .el-image {
            height: 100%;
            width: 100%;
          }
        }

        .reasons-text {
          padding-top: 35px;

          b {
            font-size: 30px;
            color: #1E50AE;
          }

          p {
            margin: 7px 0 30px 0;
            font-size: 14px;
            color: #999999;
          }

          span {
            font-size: 14px;
            color: #595959;
            line-height: 24px;
            word-break: break-all;
          }
        }
      }
    }
  }
}
</style>